const QUERY_PARAM = 'replayTicket'

export const getReplayTicket = (search = window.location.search) => (
  new URLSearchParams(search).get(QUERY_PARAM) || ''
)

export const hasReplayTicket = (isReplayEnabled, search) => !!isReplayEnabled && !!getReplayTicket(search)

// Not gated on the client flag: it may still be loading on the join call, and the server checks the flag and signature.
export const withReplayTicket = (payload, search) => {
  const replayTicket = getReplayTicket(search)
  return replayTicket ? { ...payload, replayTicket } : payload
}
